import { render, staticRenderFns } from "./ChatbotFaqsList.vue?vue&type=template&id=16835276&scoped=true"
import script from "./ChatbotFaqsList.vue?vue&type=script&lang=js"
export * from "./ChatbotFaqsList.vue?vue&type=script&lang=js"
import style0 from "./ChatbotFaqsList.vue?vue&type=style&index=0&id=16835276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16835276",
  null
  
)

export default component.exports